import { openZohoChat } from '../utils/openZohoChat';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';

export default function ChatBar() {
  return (
    <div className="float-bar">
      <a href={SUPPORT_PHONE_TEL} className="float-bar__btn float-bar__btn--call">
        <span aria-hidden="true">☎</span> {SUPPORT_PHONE_LABEL}
      </a>
      <button type="button" className="float-bar__btn float-bar__btn--chat" onClick={openZohoChat}>
        Live Chat
      </button>
    </div>
  );
}
